import LinkNext from "next/link";
import classNames from "classnames";

import { LinkProps } from "./types";

import "./styles.scss";

export const Link = ({ children, href, className, ...rest }: LinkProps) => {
  const classnames = classNames("link", {
    [`${className}`]: className,
  });

  return (
    <LinkNext href={href} className={classnames} {...rest}>
      {children}
    </LinkNext>
  );
};
